/**
 * What happened to your account lately: sign-ins (with a password, Google, GitHub, a recovery
 * code), password and two-step changes. Something you did not do is a reason to change your
 * password and sign out everywhere else.
 */
import { For, createResource, type JSX } from "solid-js";
import { formatDate } from "../shared/ui";
import { usePages } from "./context";

/** The activity section. */
export function AccountActivity(): JSX.Element {
  const { accounts, server } = usePages();
  const [lines] = createResource(() => accounts.call(server, (a) => a.activity(), true));
  return (
    <section class="team-section" id="account-activity">
      <h3>Recent activity</h3>
      <ul class="activity-list">
        <For each={lines() ?? []} fallback={<li class="muted small">Nothing yet.</li>}>
          {(line) => (
            <li data-activity={line.action}>
              <span class="muted small">{formatDate(line.at)}</span> {line.detail}
            </li>
          )}
        </For>
      </ul>
    </section>
  );
}
